import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e009573"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loader-overlay flex justify-center items-center"
}
const _hoisted_2 = { class: "items-center" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-white mt-3 text-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Loading token"),
  /*#__PURE__*/_createTextVNode(" This may take a few seconds to a few minutes depending on your internet connection. ")
], -1))
const _hoisted_5 = { class: "p-3" }
const _hoisted_6 = {
  key: 0,
  class: "bg-blue-primary rounded-md"
}
const _hoisted_7 = { class: "text-center p-3" }
const _hoisted_8 = { class: "text-center text-white text-sm" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Update token image.  ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Add Image ")
const _hoisted_11 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_12 = {
  key: 1,
  class: "my-3 text-gray-300 text-sm"
}
const _hoisted_13 = { class: "flex text-white items-center" }
const _hoisted_14 = { class: "inline-block mt-3 ml-4 mb-3" }
const _hoisted_15 = { class: "pt-3 ml-4" }
const _hoisted_16 = { class: "text-xl text-gray-300 font-semibold" }
const _hoisted_17 = { class: "text-gray-text" }
const _hoisted_18 = { class: "text-gray-text" }
const _hoisted_19 = { class: "flex flex-row items-center text-sm border-b border-black-border mainTab mt-2" }
const _hoisted_20 = { role: "presentation" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xr-icon-token" }, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("  Token Supply")
const _hoisted_23 = [
  _hoisted_21,
  _hoisted_22
]
const _hoisted_24 = { role: "presentation" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xr-icon-game" }, null, -1))
const _hoisted_26 = /*#__PURE__*/_createTextVNode("  Linked Games")
const _hoisted_27 = [
  _hoisted_25,
  _hoisted_26
]
const _hoisted_28 = {
  class: "tab-content",
  id: "pills-tabContent"
}
const _hoisted_29 = {
  key: 0,
  class: "bg-black-body p-7 text-white"
}
const _hoisted_30 = { class: "w-full" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-2 text-xl" }, "Token Supply", -1))
const _hoisted_32 = { class: "md:grid md:grid-cols-2 mt-5 w-full lg:w-100 xl:w-200" }
const _hoisted_33 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_34 = { class: "w-full text-white p-3 bg-black-header" }
const _hoisted_35 = { class: "flex items-center" }
const _hoisted_36 = /*#__PURE__*/_createStaticVNode("<span class=\"icon xr-test-net mr-2 inline-block\" data-v-5e009573><span class=\"path1\" data-v-5e009573></span><span class=\"path2\" data-v-5e009573></span><span class=\"path3\" data-v-5e009573></span><span class=\"path4\" data-v-5e009573></span></span>", 1)
const _hoisted_37 = { class: "m-0" }
const _hoisted_38 = { class: "p-3 border-t border-black-border bg-black-header w-full text-md flex-grow" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text mb-1" }, "Circulation Supply", -1))
const _hoisted_40 = { class: "text-yellow-bar font-bold my-2 mb-4" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text my-1" }, "Assigned Asset ID", -1))
const _hoisted_42 = { class: "text-white my-2 mb-4" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-gray-text mb-2" }, "Linked Namespaces", -1))
const _hoisted_44 = {
  key: 0,
  class: "mr-1 mb-1 inline-block max-w-full text-sm"
}
const _hoisted_45 = {
  key: 1,
  class: "bg-black-body p-7 text-white"
}
const _hoisted_46 = {
  key: 1,
  class: "modal fade show update-game-modal",
  id: "modalUploadTokenPhoto",
  tabindex: "-1",
  "aria-labelledby": "staticBackdropLabel",
  "aria-hidden": "true"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_tokensCreateMainnetAssetComponent = _resolveComponent("tokensCreateMainnetAssetComponent")!
  const _component_tokensLinkedGamesComponent = _resolveComponent("tokensLinkedGamesComponent")!
  const _component_uploadTokenPhoto = _resolveComponent("uploadTokenPhoto")!

  return (_openBlock(), _createElementBlock("main", null, [
    (_ctx.showLoader)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: require('@/assets/images/xr_loader.gif'),
              style: {"width":"120px","height":"120px"},
              class: "inline-block"
            }, null, 8, _hoisted_3),
            _hoisted_4
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      (_ctx.isDisplayUploadTokenImageLabel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("button", {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$refs.fileInput.click())),
                  class: "border border-blue-900 p-1 px-2 bg-blue-900 hover:bg-blue-800 transition-all duration-200 rounded-md"
                }, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: "fa-solid fa-camera",
                    class: "text-white inline-block mr-2"
                  }),
                  _hoisted_10
                ]),
                _createElementVNode("input", {
                  style: {"display":"none"},
                  ref: "fileInput",
                  type: "file",
                  onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.pickFile && _ctx.pickFile(...args))),
                  accept: ".png, .jpg, .jpeg"
                }, null, 544),
                (_ctx.isDisplaySaveTokenImageOptions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("button", {
                        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.updateTokenImage && _ctx.updateTokenImage(...args))),
                        class: "mr-3 border border-success-check bg-success-check text-white p-1 px-2 hover:bg-green-700 duration-200 transition-all rounded-md"
                      }, "Confirm"),
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.revertTokenImage && _ctx.revertTokenImage(...args))),
                        class: "hover:underline"
                      }, "Cancel")
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isDisplaySaveTokenImageUploading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, "Uploading token image ..."))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", {
            class: "border-black-border relative border border-dotted rounded-3xl w-36 bottom-0 h-36 left-0 bg-cover bg-center bg-black-body",
            style: _normalizeStyle({ 'background-image': `url(${_ctx.previewImage})` })
          }, [
            _createElementVNode("button", {
              class: "bg-black-body p-2 rounded-lg absolute",
              style: {"bottom":"0px","left":"0"},
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isDisplayUploadTokenImageLabel = !_ctx.isDisplayUploadTokenImageLabel))
            }, [
              _createVNode(_component_font_awesome_icon, {
                icon: "fa-solid fa-camera",
                class: "text-gray-text text-xl"
              })
            ])
          ], 4)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.tokenName), 1),
          _createElementVNode("h5", _hoisted_17, _toDisplayString(_ctx.tokenData.symbol), 1),
          _createElementVNode("h5", _hoisted_18, _toDisplayString(_ctx.typeLabel) + " (" + _toDisplayString(_ctx.tokenData.type) + ")", 1)
        ])
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("ul", _hoisted_19, [
          _createElementVNode("li", _hoisted_20, [
            _createElementVNode("button", {
              class: _normalizeClass(["text-gray-text p-3 hover:text-white", _ctx.mainTabSelected=='supply'?'active':'inActive']),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mainTabSelected = 'supply'))
            }, _hoisted_23, 2)
          ]),
          _createElementVNode("li", _hoisted_24, [
            _createElementVNode("button", {
              class: _normalizeClass(["text-gray-text p-3 hover:text-white", _ctx.mainTabSelected=='linkedGames'?'active':'inActive']),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mainTabSelected = 'linkedGames'))
            }, _hoisted_27, 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_28, [
          (_ctx.mainTabSelected == 'supply')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("div", _hoisted_32, [
                    (_ctx.testnetTokenId != '-')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                          _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("div", _hoisted_35, [
                              _hoisted_36,
                              _createElementVNode("p", _hoisted_37, "Token in " + _toDisplayString(_ctx.testnetLabel), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _hoisted_39,
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.tokenData.formattedAmount), 1),
                            _hoisted_41,
                            _createElementVNode("h6", _hoisted_42, _toDisplayString(_ctx.tokenData.tokenId), 1),
                            _hoisted_43,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokenData.names, (name, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "badge-gray mr-1 mb-1 inline-block truncate max-w-full",
                                key: index
                              }, _toDisplayString(name), 1))
                            }), 128)),
                            (!_ctx.tokenData.names)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_44, "None"))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: _normalizeClass(["mt-3 md:mt-0 flex flex-col", _ctx.testnetTokenId!='-'?'md:pl-1.5':''])
                    }, [
                      _createVNode(_component_tokensCreateMainnetAssetComponent, {
                        testnetAssetId: _ctx.tokenData.tokenId,
                        tokenName: _ctx.tokenName,
                        symbol: _ctx.tokenData.symbol,
                        tokenType: _ctx.tokenData.type,
                        tokenImage: _ctx.previewImage,
                        supply: _ctx.tokenData.amount
                      }, null, 8, ["testnetAssetId", "tokenName", "symbol", "tokenType", "tokenImage", "supply"])
                    ], 2)
                  ])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_45, [
                (_ctx.$route.params.testnetTokenId)
                  ? (_openBlock(), _createBlock(_component_tokensLinkedGamesComponent, {
                      key: 0,
                      network: "testnet",
                      tokenId: _ctx.$route.params.testnetTokenId.toString(),
                      class: "mb-10"
                    }, null, 8, ["tokenId"]))
                  : _createCommentVNode("", true),
                (_ctx.$route.params.mainnetTokenId)
                  ? (_openBlock(), _createBlock(_component_tokensLinkedGamesComponent, {
                      key: 1,
                      network: "mainnet",
                      tokenId: _ctx.$route.params.mainnetTokenId.toString()
                    }, null, 8, ["tokenId"]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ])
    ]),
    false
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _createVNode(_component_uploadTokenPhoto)
        ]))
      : _createCommentVNode("", true)
  ]))
}